import { useApi, useSavingsHistoric } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [activeDisplayOption, setActiveDisplayOption] = useState('total');

  const displayOptions = useMemo(
    () => [
      { key: 'total', value: 'Supply' },
      { key: 'rate', value: 'Savings Rate' },
      { key: 'utilization', value: 'Utilization' }
    ],
    []
  );

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: '/save/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const [savingsRows, savingsError] = useSavingsHistoric(chartDaysAgo);

  // The rates come from atlas; the supply and the utilization from sky-api.
  const isRate = activeDisplayOption === 'rate';
  const chartData = useMemo(
    () =>
      isRate
        ? data
        : savingsRows?.filter((row) => row[activeDisplayOption] != null),
    [isRate, data, savingsRows, activeDisplayOption]
  );

  if (error) {
    throw error;
  }
  if (!isRate && savingsError) {
    throw savingsError;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {chartData ? (
        <HistoricGraphs
          data={chartData}
          timeFilter={timeFilter}
          activeDisplayOption={activeDisplayOption}
          chartDaysAgo={chartDaysAgo}
        />
      ) : (
        <ChartSkeleton />
      )}
    </Flex>
  );
}
